/**
 * @file: ApiFromModel.js 基类
 * @author: liuye11(liuye11@baidu.com)
 */

import FormModel from '@baidu/ve-ria/views/FormModel';

export default class CustomServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    serviceType = 'custom';

    crumbData = [
        {
            to: '/app/service/list',
            text: '服务管理'
        },
        {
            to: '/app/service/custom/api/list',
            text: 'API管理'
        },
        {
            text: 'API'
        }
    ];

    proxyUrlPrefix = `https://${process.env.VUE_APP_MUSES_SANDBOX_URL}/plain/thirdparty`;
    init() {
        super.init();
        let {appId, serviceId, apiId} = this.getRouteParams();
        this.setCrumbData(appId, serviceId, apiId);
        this.id = apiId;
        this.serviceId = serviceId;
        this.isAdmin = !!this.getRouteMeta().isAdmin;
    }

    setCrumbData(appId, serviceId) {
        this.appPrefix = this.removeEndLash(`/app/${appId || ''}`);
        this.servicePrefix = this.removeEndLash(`/service/${serviceId || ''}`);

        this.crumbData[0].to = `${this.appPrefix}/service/list`;
        this.crumbData[1].to = `${this.appPrefix}${this.servicePrefix}/custom/api/list`;
    }

    removeEndLash(str) {
        // 去除最后一个 '/'
        return str && str.replace(/\/$/, '');
    }
    removeStartSlash(str) {
        // 去除第一个 '/'
        return str && str.replace(/^\/+/, '');
    }

    getApiListUrl() {
        if (this.isAdmin) {
            return `${this.servicePrefix}/custom/api/list`;
        }
        return this.crumbData[1].to;
    }
}
